import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { MapPin, Calendar, Users } from 'lucide-react';

export const WeddingCard = ({ wedding }) => {
  const { t, formatCurrency, formatDate } = useLanguage();

  const defaultImage = "https://images.pexels.com/photos/33485955/pexels-photo-33485955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

  // Verification status badge config
  const verificationBadge = {
    pending: { text: t('wedding.verification.pending'), color: 'bg-yellow-500' },
    verified: { text: t('wedding.verification.verified'), color: 'bg-green-500' },
    rejected: { text: t('wedding.verification.rejected'), color: 'bg-red-500' },
  };

  return (
    <Card
      className="group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-lg transition-all duration-300 border border-border/50"
      data-testid={`wedding-card-${wedding.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={wedding.images?.[0] || defaultImage}
          alt={wedding.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {wedding.is_featured && (
          <Badge className="absolute top-3 left-3 bg-primary text-white">
            Featured
          </Badge>
        )}
        {/* Verification Badge */}
        {wedding.verification_status && verificationBadge[wedding.verification_status] && (
          <Badge
            className={`absolute top-2 left-2 ${verificationBadge[wedding.verification_status].color} text-white`}
          >
            {verificationBadge[wedding.verification_status].text}
          </Badge>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-3 left-3 right-3">
          <p className="text-white font-medium text-lg line-clamp-1">{wedding.title}</p>
        </div>
      </div>

      <CardContent className="p-4">
        <div className="space-y-3">
          <div className="flex items-center text-muted-foreground text-sm">
            <MapPin className="h-4 w-4 mr-1.5 text-primary" />
            <span className="line-clamp-1">{wedding.location}</span>
          </div>

          <div className="flex items-center text-muted-foreground text-sm">
            <Calendar className="h-4 w-4 mr-1.5 text-primary" />
            <span>{formatDate(wedding.date)}</span>
          </div>

          <div className="flex items-center text-muted-foreground text-sm">
            <Users className="h-4 w-4 mr-1.5 text-primary" />
            <span>{wedding.available_slots} {t('wedding.card.slots')}</span>
          </div>

          <div className="flex items-center justify-between pt-2 border-t border-border">
            <div>
              <span className="text-2xl font-bold text-foreground">
                {formatCurrency(wedding.price_per_guest, wedding.currency)}
              </span>
              <span className="text-sm text-muted-foreground ml-1">
                {t('wedding.card.perGuest')}
              </span>
            </div>
            <Button asChild size="sm" className="rounded-full">
              <Link to={`/weddings/${wedding.id}`} data-testid={`view-wedding-${wedding.id}`}>
                {t('wedding.card.viewDetails')}
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WeddingCard;